// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Modal} from '../../../../shared/ui/modal';
import {Button} from '../../../../shared/button';
import {format_sa2025_local_date, SA2025_FREE_WATCH_TIME_DAYS}
    from './use_sa2025';

import styles from './styles.module.less';

interface i_settlement_popup_props {
    is_open: boolean;
    on_close: ()=>void;
    on_receive_benefit: ()=>void;
    is_client: boolean;
    benefit_type?: string;
}

export const Settlement_popup = (props: i_settlement_popup_props)=>{
    const {is_open, on_close, on_receive_benefit, is_client, benefit_type,
    } = props;
    if (!is_client)
        return null;
    const is_membership = benefit_type=='membership';
    const is_refund = benefit_type=='refund';
    if (!is_membership && !is_refund)
        return null;
    return <Modal is_open={is_open} on_close={on_close}
      paddingless no_logo width={468}>
      <div className={cn(styles.sa2025_popup)}>
        <div className={cn(styles.content_section)}>
          <div className={cn(styles.title_and_content)}>
            <div className={cn(styles.title)}>
              Dear Hola user,
            </div>
            <div className={cn(styles.content)}>
              {is_membership ? <>
                Beginning on {format_sa2025_local_date()}, you are entitled
                to {SA2025_FREE_WATCH_TIME_DAYS} days of free use of the
                Hola Watch Time package, subject and according to the terms
                of this benefit on Hola's website, and in accordance with
                the class action settlement in CA (Dist. - TA) 62567-02-22.
              </> : <>
                Subject to a declaration that you were a user of Hola
                services during the period from January 2015 until 23 July
                2025, or during any part of this term, you will be entitled
                to a refund of 3 NIS, subject to and in accordance with
                this benefit's terms on the Hola website, and in accordance
                with the class action settlement in CA (Dist. - TA)
                62567-02-22.
              </>}
            </div>
            <div className={styles.button_wrapper}>
              <Button caption={is_membership ? 'Got it' :
                'Receive the benefit'}
                size="md" round on_click={on_receive_benefit}
                cls={styles.button}/>
            </div>
          </div>
          <div className={cn(styles.footer)}>
            This message is being published in accordance with the
            confirmation of the Tel Aviv District Court of 23 July 2025
          </div>
        </div>
      </div>
    </Modal>;
};
